import { createSelector } from 'reselect';
import TableDefinitions from '../../../../../common/TableDefinitions';
import DataSharingColumns from '../../containers/DataSharingColumns';

export const getDataSharingData = TableDefinitions.DATA_SHARING_VIEW.getDataFunction();
export const getDataSharingIsLoading = (state) => state.listing.DATA_SHARING_VIEW.isLoading;
export const getDataSharingColumns = createSelector(getDataSharingData, DataSharingColumns);
